import React from "react";
import { activeFilterPageInfo } from "../../../../../services/FilteringUtils";
import KnowledgeCopyrightService from "../../../../../services/KnowledgeCopyrightService";
import PageComponent from "../../../page/PageComponent";
import AdditionalData from "./AdditionalData";

class AdditionalDataContaier extends PageComponent {
  constructor(props) {
    super(props);
    this.state = {
      knowledgeCopyrights: []
    };

    this.knowledgeCopyrightService = new KnowledgeCopyrightService();
  }

  componentDidMount() {
    this.loadKnowledgeCopyrights();
  }
  loadKnowledgeCopyrights = () => {
    this.prepareCall(
      this.knowledgeCopyrightService.getEntities(
        activeFilterPageInfo,
        this.sortInfo,
        this.onKnowledgeCopyrightsLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onKnowledgeCopyrightsLoad = data => {
    const knowledgeCopyrights = data._embedded ? data._embedded.content : [];
    this.setState({ knowledgeCopyrights: knowledgeCopyrights });
  };

  render() {
    return (
      <AdditionalData
        knowledgeCopyrights={this.state.knowledgeCopyrights}
        validationRules={this.props.validationRules}
        processes={this.props.processes}
        partyId={this.props.partyId}
        onChange={this.props.onChange}
        knowledgeItem={this.props.knowledgeItem}
        editable={this.props.editable}
      />
    );
  }
}

export default AdditionalDataContaier;
